import { Sheet } from '@/components/Sheet';
import { plural, type Strings } from '@/str';

const BTN_GO =
  'bg-primary text-primary-foreground text-t15 rounded-plate min-h-13 w-full px-4 py-3.5 font-extrabold active:scale-[0.98]';
const BTN_ALT =
  'border-border-strong text-foreground text-t14 rounded-plate min-h-12 w-full border bg-transparent px-4 py-3 font-bold active:scale-[0.98]';

export function GapSheet({
  count,
  t,
  onGo,
  onFinish,
  onClose,
}: {
  count: number;
  t: Strings;
  onGo: () => void;
  onFinish: () => void;
  onClose: () => void;
}) {
  return (
    <Sheet
      edge="warn"
      strongScrim
      label={t.exp.gapHead.split('{n}').join(String(count))}
      onClose={onClose}
    >
      <div data-sheet="gaps" className="text-t19 font-extrabold tracking-tight text-pretty">
        {t.exp.gapHead.split('{n}').join(String(count))}
      </div>
      <div className="text-t13 text-muted-foreground leading-[1.5] text-pretty">
        {t.exp.gapBody}
      </div>
      <button type="button" className={BTN_GO} onClick={onGo}>
        {t.exp.gapGo}
      </button>
      <button type="button" className={BTN_ALT} onClick={onFinish}>
        {t.exp.gapFinish}
      </button>
    </Sheet>
  );
}

export function PracticeResult({
  correct,
  total,
  t,
  doneLabel,
  onAgain,
  onHome,
  onClose,
}: {
  correct: number;
  total: number;
  t: Strings;
  doneLabel?: string;
  onAgain: () => void;
  onHome: () => void;
  onClose: () => void;
}) {
  const passed = correct >= 18;
  return (
    <Sheet strongScrim label={t.exp.resHead} onClose={onClose}>
      <div data-sheet="result" className="text-t11 text-faint tracking-kicker font-bold uppercase">
        {t.exp.resHead}
      </div>
      <div className="text-t40 leading-none font-extrabold tracking-[-0.04em] tabular-nums">
        {t.exp.resScore.split('{c}').join(String(correct)).split('{n}').join(String(total))}
      </div>
      {total === 20 && (
        <div
          data-pass={passed || undefined}
          className="text-t13 text-warn data-pass:text-ok leading-[1.45] font-bold text-pretty"
        >
          {passed ? t.exp.resPass : t.exp.resFail}
        </div>
      )}
      <button type="button" className={`${BTN_GO} mt-1`} onClick={onAgain}>
        {t.exp.resAgain
          .split('{n}')
          .join(String(total))
          .split('{u}')
          .join(plural(total, t.savolUnit))}
      </button>
      <button type="button" className={BTN_ALT} onClick={onHome}>
        {doneLabel ?? t.exp.resHome}
      </button>
    </Sheet>
  );
}
